import React, { useEffect } from "react";
import SimpleBar from "simplebar-react";

import SidebarContent from "./SidebarContent";

const Sidebar = ({ layoutType }) => {
  useEffect(() => {
    const overlay = document.getElementsByClassName("vertical-overlay");
    if (overlay && overlay[0]) {
      overlay[0].addEventListener("click", () => {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <SimpleBar id="scrollbar" className="h-full">
          <div className="w-full px-2 py-4">
            <ul className="navbar-nav space-y-1" id="navbar-nav">
              <SidebarContent layoutType={layoutType} />
            </ul>
          </div>
        </SimpleBar>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
